import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { fromEvent, of } from 'rxjs';
import { filter, map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ProtocolTableComponent } from '../protocol-table/protocol-table.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PatientService } from 'src/app/services/patient.service';
import { ProtocolEditDialogComponent } from 'src/app/dialogs/protocol/protocol-edit-dialog/protocol-edit-dialog.component';

@ManageType('ProtocolPanelComponent')
@Component({
  selector: 'app-protocol-panel',
  templateUrl: './protocol-panel.component.html',
  styleUrls: ['./protocol-panel.component.scss']
})
export class ProtocolPanelComponent implements OnInit {

  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild('protocolTable', { static: true }) protocolTable: ProtocolTableComponent;

  constructor(public patientService: PatientService, private dialog: MatDialog) { }

  ngOnInit(): void {
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(500)
      , distinctUntilChanged()
      // subscription for response
    ).subscribe((text: string) => {
      if (text.length < 3) {
        // Clean
        this.protocolTable.subject.query(0, this.protocolTable.subject.limit, undefined);
      } else {
        this.protocolTable.subject.query(0, this.protocolTable.subject.limit, text);
      }
    }, (err) => {
      console.log('error', err);
    });
  }

  newProtocol(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
        patient: this.patientService.patient
    };
    const dialogRef = this.dialog.open(ProtocolEditDialogComponent, dialogConfig);
  }

}
